import './App.css';
import { Content } from './components/Content';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div>
          <Content></Content>
        </div>
      </header>
    </div>
  );
}

export default App;
